// extracted by mini-css-extract-plugin
export default {"lottie-container":"LottiePlayer_lottie-container__1M-TI"};